import { useLanguageContext } from "../../../../context/LanguageContext";
import SaltoConfigsPage from "../../../../pages/integrations/salto/SaltoConfigsPage";
import { useSaltoConfigsRouteValidator } from "../../../validators/integrations/salto/SaltoConfigsRouteValidator";
import { RouteConfig } from "../../RouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useSaltoConfigsRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/integrations/salto")
    .setLabel(translate("eva.main.entities.salto_config"))
    .setValidator(useSaltoConfigsRouteValidator())
    .setPage(<SaltoConfigsPage />);
}

export default useSaltoConfigsRouteConfig;
